export default "__VITE_ASSET__mW0P7iYC__"